import React, { useState, useContext } from "react";
import Loader from "./Loader";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { capitalizeEachWord } from "../../utils/application-helper";
import info from "../img/info.png";

const ServiceList = ({
  loading,
  serviceList,
  editHandler,
  deleteHandler,
  isOtherUser = false,
  otherProfile = {},
}) => {
  const [isOpenArray, setIsOpenArray] = useState(serviceList.map(() => false));
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const appContext = useContext(AppContext);

  const isUserGoogle = user?.google_gmail || user?.data?.data?.google_gmail;

  const subscriptionPlan =
    user?.subscription?.main_plan_name ||
    user?.data?.data?.subscription?.main_plan_name;

  const path = location.pathname.trim().split("/")[2];

  const toggleDiv = (index) => {
    const newIsOpenArray = [...isOpenArray];
    newIsOpenArray[index] = !newIsOpenArray[index];
    setIsOpenArray(newIsOpenArray);
  };

  const navigateHandler = (service) => {
    if (
      otherProfile?.main_plan_name === "Basic" ||
      subscriptionPlan === "Basic"
    ) {
      appContext.updateModalType("subscriptionAlert", "Subscription", {
        name: subscriptionPlan,
        content:
          subscriptionPlan === "Basic"
            ? "Please subscribe to premium plan to avail this service"
            : "This user is not subscribed to the Premium plan, so you cannot book his/her services.",
      });
      return;
    }
    if (service.status === "Accepted") {
      if (!isUserGoogle || isUserGoogle === "") {
        appContext.updateNotificationState({
          show: true,
          message: "Please add google account to book services",
          type: "error",
        });
        navigate("/myspace/calendar");
      } else if (service.google_gmail === "") {
        appContext.updateNotificationState({
          show: true,
          message:
            "Please ask the expert to add google account to book services",
          type: "error",
        });
      } else {
        navigate(`/user/${path}/services/bookings`, {
          state: {
            serviceId: service.id,
            amount: service.amount,
            type: service.serviceName,
            expertise: service.expertise,
            noOfSessions: service.noOfSessions,
          },
        });
      }
    } else {
      const type =
        service.id === "fl" ? "Freelancing services" : "Upskilling services";
      navigate(`../user/${path}/ask-query`, {
        state: {
          type: type,
        },
      });
    }
  };

  // const symbol = localStorage.getItem("symbol");

  return (
    <>
      {loading && <Loader />}
      {!loading && serviceList.length === 0 && <p>No services available</p>}
      {!loading &&
        serviceList.length > 0 &&
        serviceList.map((service) => {
          const {
            id,
            serviceName,
            duration,
            amount,
            noOfSessions,
            queryStartTime,
            queryEndTime,
          } = service;

          return (
            (isOtherUser === false ||
              (isOtherUser === true && service?.service_status === true)) && (
              <div className="card mb-4">
                <div className="card-body p-3">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12">
                      <div className="d-flex w-100 justify-content-between align-items-center">
                        <div className="service-session-wrapper">
                          <div>
                            <p className="mb-0">
                              {serviceName && capitalizeEachWord(serviceName)}
                              {/* {"₹"} {amount}) */}
                              <div className="tool-tip">
                                <div className="info-icon">
                                  <img src={info} alt="info" />
                                </div>
                                <div className="tooltiptext top-hover">
                                  <div>
                                    <b>Session amount: </b>
                                    {"₹"} {amount}
                                  </div>
                                  {id !== "fl" &&
                                    serviceName !== "Single session" && (
                                      <div>
                                        <b>No. of Session: </b>
                                        {noOfSessions} sessions per{" "}
                                        {serviceName === "weekly sessions"
                                          ? "week"
                                          : "month"}
                                      </div>
                                    )}
                                  {id !== "fl" && (
                                    <div>
                                      <b>Session duration: </b>
                                      {duration} mins /day
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* )} */}
                            </p>
                          </div>

                          {/* <div>
                          {service.duration && (
                            <p className="mb-0">
                              {duration} mins{" "}
                              {serviceName !== "Single session" ? "/ day" : ""}
                            </p>
                          )}
                        </div> */}
                        </div>
                        <div
                          className={
                            service.status === "Accepted" ? "w-20" : "w-30"
                          }
                        >
                          {isOtherUser && service?.status !== "Pending" && (
                            <div className="arrow p-1">
                              {service?.status !== "Pending" && (
                                <p
                                  className="mb-0 cursor-pointer d-flex justify-content-center align-items-center query-btn"
                                  onClick={() => navigateHandler(service)}
                                >
                                  {service.status === "Accepted"
                                    ? "Book"
                                    : "Send query"}
                                  <span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                    >
                                      <path
                                        d="M3.55566 8.81334C3.55566 8.55493 3.74769 8.34138 3.99682 8.30758L4.06608 8.30292L13.0385 8.30333L9.79705 5.07509C9.59729 4.87619 9.59659 4.55302 9.79549 4.35326C9.97631 4.17166 10.2598 4.15457 10.46 4.30241L10.5173 4.3517L14.6347 8.45137C14.661 8.47759 14.6839 8.50596 14.7033 8.53593C14.7088 8.54495 14.7144 8.55417 14.7197 8.56359C14.7245 8.57166 14.7289 8.58003 14.7331 8.5885C14.7388 8.60083 14.7445 8.61356 14.7496 8.62655C14.7537 8.63657 14.7572 8.64631 14.7604 8.65613C14.7641 8.66831 14.7678 8.68129 14.7709 8.69446C14.7733 8.70366 14.7751 8.71252 14.7767 8.7214C14.779 8.73463 14.7809 8.74831 14.7823 8.76216C14.7835 8.77272 14.7842 8.78318 14.7846 8.79366C14.7847 8.80001 14.7848 8.80666 14.7848 8.81334L14.7846 8.83311C14.7842 8.84313 14.7835 8.85314 14.7825 8.86312L14.7848 8.81334C14.7848 8.84555 14.7818 8.87706 14.7761 8.90761C14.7748 8.91491 14.7732 8.9224 14.7715 8.92986C14.7679 8.94523 14.7637 8.96003 14.7589 8.97453C14.7565 8.98174 14.7537 8.98944 14.7508 8.99708C14.7448 9.01244 14.7383 9.02708 14.7312 9.04134C14.7279 9.04805 14.7242 9.05507 14.7203 9.06202C14.7139 9.07335 14.7073 9.08413 14.7004 9.09463C14.6955 9.10206 14.6901 9.1098 14.6844 9.11741L14.68 9.12329C14.6662 9.14126 14.6513 9.15828 14.6353 9.17426L14.6347 9.17473L10.5174 13.2751C10.3176 13.474 9.99444 13.4733 9.79552 13.2736C9.61469 13.092 9.5988 12.8084 9.74748 12.6089L9.79702 12.5517L13.0372 9.32416L4.06608 9.32375C3.78419 9.32375 3.55566 9.09523 3.55566 8.81334Z"
                                        fill="black"
                                        fillOpacity="0.6"
                                      />
                                    </svg>
                                  </span>
                                </p>
                              )}
                              {/* </NavLink> */}
                            </div>
                          )}
                          {isOtherUser === false && (
                            <div className="edit-delete-buttons">
                              <span
                                onClick={() => editHandler(service)}
                                className="mr-2"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="15"
                                  height="17"
                                  viewBox="0 0 15 17"
                                  fill="none"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12.4303 1.0447C12.472 1.0772 13.8661 2.16054 13.8661 2.16054C14.3728 2.4622 14.7686 3.00137 14.9186 3.6397C15.0678 4.27137 14.9595 4.92303 14.612 5.47387C14.6097 5.47754 14.6074 5.48117 14.5993 5.49197L14.593 5.50031C14.5366 5.57465 14.2914 5.8847 13.0539 7.43519C13.0424 7.45551 13.0294 7.47454 13.0151 7.49303C12.9943 7.52029 12.9716 7.54535 12.9473 7.56817C12.8629 7.67445 12.7738 7.78612 12.68 7.90353L12.4901 8.14142C12.0982 8.63223 11.6333 9.21424 11.0818 9.90455L10.7988 10.2588C9.73404 11.5914 8.37044 13.2977 6.62364 15.483C6.24114 15.9597 5.66781 16.2372 5.05198 16.2447L2.01948 16.283H2.01114C1.72198 16.283 1.47031 16.0847 1.40281 15.8022L0.72031 12.9097C0.579477 12.3105 0.719477 11.6922 1.10364 11.2122L8.95364 1.39387C8.95698 1.39054 8.95948 1.38637 8.96281 1.38304C9.82364 0.353869 11.3803 0.202202 12.4303 1.0447ZM8.07842 4.48917L2.07948 11.993C1.93698 12.1714 1.88448 12.4014 1.93698 12.6222L2.50448 15.0264L5.03698 14.9947C5.27781 14.9922 5.50031 14.8847 5.64781 14.7014C6.40738 13.751 7.36202 12.5566 8.34352 11.3283L8.69077 10.8938L9.03861 10.4585C9.9591 9.30657 10.8685 8.16839 11.6294 7.21572L8.07842 4.48917ZM9.92531 2.18054L8.85925 3.5125L12.4099 6.23827C13.0933 5.38225 13.5429 4.81845 13.5845 4.7647C13.7211 4.54304 13.7745 4.2297 13.7028 3.92804C13.6295 3.61887 13.437 3.35637 13.1595 3.18887C13.1003 3.14804 11.6961 2.05804 11.6528 2.02387C11.1245 1.60054 10.3536 1.67387 9.92531 2.18054Z"
                                    fill="#575757"
                                  />
                                </svg>
                              </span>

                              {/* <span onClick={() => deleteHandler(id)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                              >
                                <path
                                  d="M0.758057 11.2428L6.00106 5.99984L11.2441 11.2428M11.2441 0.756836L6.00006 5.99984L0.758057 0.756836"
                                  stroke="black"
                                  strokeOpacity="0.5"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span> */}
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  checked={service?.service_status}
                                  onChange={() => deleteHandler(service)}
                                />
                                <span class="slider round"></span>
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {/*                   
                  <div className="col-md-5">

                  </div>
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-8">

                      </div>
                      <div className="col-md-4">

                      </div>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            )
          );
        })}
    </>
  );
};

export default ServiceList;
